// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-width: 1200px){h3,h4{margin-bottom:10px !important}h2{margin-bottom:10px !important}}\n", ""]);
// Exports
module.exports = exports;
